module.exports = __webpack_public_path__ + "static/media/information_Patient_1.0.bd7820e9.pdf";